import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";
import { v4 as uuidv4 } from "uuid";

export type VimeoPlayerProps = ComponentProps<"div"> & {
  videoId: string;
  title: string;
  hash?: string;
};

const vimeoPlayerVariants = tv({
  slots: {
    container: "aspect-video w-full",
  },
});

const { container } = vimeoPlayerVariants();

const uniqueId = uuidv4();

export const VimeoPlayer = ({ className, hash, title, videoId, ...props }: VimeoPlayerProps) => {
  const getIframeSrc = () => {
    const url = new URL(`https://player.vimeo.com/video/${videoId}`);
    const params = new URLSearchParams({
      badge: "0", // Hides the Vimeo badge/logo from the player
      autoplay: "1", // Automatically starts playing the video when loaded
      player_id: uniqueId, // Unique identifier for this player instance
      app_id: "58479", // Vimeo application ID for tracking and analytics
    });

    if (hash) {
      params.set("h", hash);
    }

    url.search = params.toString();

    return url.toString();
  };

  return (
    <div className={container({ className })} {...props}>
      <iframe
        allow="autoplay; fullscreen; picture-in-picture"
        className="size-full"
        src={getIframeSrc()}
        title={title}
        allowFullScreen
      />
    </div>
  );
};
